import { render, staticRenderFns } from "./DossierOperationalBase.vue?vue&type=template&id=3d45d10a&scoped=true&"
import script from "./DossierOperationalBase.vue?vue&type=script&lang=js&"
export * from "./DossierOperationalBase.vue?vue&type=script&lang=js&"
import style0 from "./DossierOperationalBase.vue?vue&type=style&index=0&id=3d45d10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45d10a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VSelect,VTextField,VTextarea})
